import { ERROR_CODE as LIB_ERROR_CODE } from '@apeiron/temp'
import * as R from 'ramda'

/**
 * @see https://docs.google.com/spreadsheets/d/1WDIcT05HhuX0BsjimTVk82dFrMeijB3hGnM0Id0ttJw/edit#gid=1342129073
 */

// 1200 ~ 1299
enum MORPH_ERROR_CODE {
  CANNOT_MORPH_CORE = 1200,
  CANNOT_GET_MORPH_RESPONSE = 1201,
  CANNOT_GET_MORPHED_PLANET = 1202
}

// 1300 ~ 1399
enum EXPEDITION_ERROR_CODE {
  CANNOT_CLAIM_REWARD = 1300,
  CANNOT_STAKE_EXTRA_TOKEN = 1301,
  CANNOT_UNSTAKE_EXTRA_TOKEN = 1302
}

// 1800 ~ 1899
enum RENTAL_ERROR_CODE {
  FAIL_TO_ATTACH = 1800
}

// 1900 ~ 1999
enum APP_CONNECT_ERROR_CODE {
  FAIL_TO_BIND_APP = 1900
}

// const - error code
export const ERROR_CODE = R.mergeDeepLeft(LIB_ERROR_CODE, {
  APP: APP_CONNECT_ERROR_CODE,
  EXPEDITION: EXPEDITION_ERROR_CODE,
  MORPH: MORPH_ERROR_CODE,
  RENTAL: RENTAL_ERROR_CODE
})
